import type { FeatureAnnouncement } from '@customer-portal/data-access/feature-announcements';

import type { BadgeTarget } from '../../interfaces';

export function getDesiredBadges(
  document: Document,
  announcements: FeatureAnnouncement[],
): Map<HTMLElement, Map<string, BadgeTarget>> {
  const desired = new Map<HTMLElement, Map<string, BadgeTarget>>();

  announcements.forEach((feature) => {
    (feature.badgeTargets ?? []).forEach((target) => {
      let hosts: Element[];

      try {
        hosts = Array.from(document.querySelectorAll(target.selector));
      } catch (error) {
        if (error instanceof DOMException && error.name === 'SyntaxError') {
          return;
        }

        throw error;
      }

      hosts.forEach((host) => {
        if (host.namespaceURI !== 'http://www.w3.org/1999/xhtml') {
          return;
        }

        const htmlHost = host as HTMLElement;
        let hostTargets = desired.get(htmlHost);

        if (!hostTargets) {
          hostTargets = new Map<string, BadgeTarget>();
          desired.set(htmlHost, hostTargets);
        }

        if (!hostTargets.has(feature.featureKey)) {
          hostTargets.set(feature.featureKey, {
            feature,
            selector: target.selector,
            tooltip: target.tooltip ?? feature.badgeTooltip ?? feature.title,
          });
        }
      });
    });
  });

  return desired;
}
